module.exports = new __parcel__URL__("empty-cmp-kanban-board.d2af34d0.svg").toString();